export default "__VITE_ASSET__BaStk4dz__"